import api from './api';
import type {
  ScholarshipAcceptancePayload,
  ScholarshipAcceptanceResponse,
} from '../components/scholarshipAcceptance/types';

class ScholarshipAcceptanceService {
  async get(token: string): Promise<ScholarshipAcceptanceResponse> {
    const response = await api.get<ScholarshipAcceptanceResponse>(
      `/scholarship/acceptance/${encodeURIComponent(token)}`
    );
    return response.data;
  }

  async save(
    token: string,
    body: ScholarshipAcceptancePayload
  ): Promise<ScholarshipAcceptanceResponse> {
    const response = await api.put<ScholarshipAcceptanceResponse>(
      `/scholarship/acceptance/${encodeURIComponent(token)}`,
      body
    );
    return response.data;
  }
}

export type {
  ScholarshipAcceptancePayload,
  ScholarshipAcceptanceResponse,
} from '../components/scholarshipAcceptance/types';

export default new ScholarshipAcceptanceService();
